import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHospital } from 'src/types/hospitals.types';
import { IUser } from 'src/types/users.types';
/*
|-----------------------------------------------------------------
| Initial State
|-----------------------------------------------------------------
|
*/

export interface IUserState {
  user: null | IUser;
  isPatient: boolean;
  userHospital: null | IHospital;
  // smsCode: string;
}

export const initialState: IUserState = {
  user: null,
  isPatient: false,
  userHospital: null
};

/*
|-----------------------------------------------------------------
| Create Slice
|-----------------------------------------------------------------
|
*/

const userState = createSlice({
  name: 'userState',
  initialState,
  reducers: {
    setUser(state: IUserState, action: PayloadAction<{ value: null | IUser }>) {
      state.user = action.payload.value;
    },

    setIsPatient(state: IUserState, action: PayloadAction<{ value: boolean }>) {
      state.isPatient = action.payload.value;
    },
    setUserHospital(
      state: IUserState,
      action: PayloadAction<{ hospital: null | any }>
    ) {
      state.userHospital = action.payload.hospital;
    }
  }
});

/*
|-----------------------------------------------------------------
| Export actions & reducer
|-----------------------------------------------------------------
|
*/
export const userActions = userState.actions;
export { default as userSelectors } from './user.selectors';

export default userState.reducer;
